export default {
  UNLOCKED: {
    value: 0,
    label: 'Unlocked'
  },
  LOCKED: {
    value: 1,
    label: 'Locked'
  }
};
